module.exports = __webpack_public_path__ + "img/fast-cash.0a127836.svg";